<template>
  <div class="layout-topbar">
    <button class="p-link layout-menu-button" @click="onMenuToggle">
      <span class="pi pi-bars"></span>
    </button>
    <div class="layout-topbar-title" id="topbar-title"></div>
    <!--    <div class="layout-topbar-icons">-->
    <!--      <span class="layout-topbar-search">-->
    <!--        <InputText type="text" placeholder="Search" />-->
    <!--        <span class="layout-topbar-search-icon pi pi-search"></span>-->
    <!--      </span>-->
    <!--      <button class="p-link">-->
    <!--        <span class="layout-topbar-item-text">Events</span>-->
    <!--        <span class="layout-topbar-icon pi pi-calendar"></span>-->
    <!--        <span class="layout-topbar-badge">5</span>-->
    <!--      </button>-->
    <!--      <button class="p-link">-->
    <!--        <span class="layout-topbar-item-text">Settings</span>-->
    <!--        <span class="layout-topbar-icon pi pi-cog"></span>-->
    <!--      </button>-->
    <!--      <button class="p-link">-->
    <!--        <span class="layout-topbar-item-text">User</span>-->
    <!--        <span class="layout-topbar-icon pi pi-user"></span>-->
    <!--      </button>-->
    <!--    </div>-->
    <!-- <div class="layout-topbar-icons" id="topbar_right">
      <AvatarGroup
        v-if="isViewer || isAdmin || isOperationPlanner || isCompanyPlanner"
      >
        <template v-if="isViewer">
          <Avatar
            label="VW"
            style="background-color: #ded7b1"
            v-tooltip.left="'Viewer'"
          ></Avatar>
        </template>
        <template v-if="isOperationPlanner"
          ><Avatar
            label="OP"
            style="background-color: #9dab86"
            v-tooltip.left="'Operation Planner'"
          ></Avatar
        ></template>
        <template v-if="isCompanyPlanner">
          <Avatar
            label="CO"
            style="background-color: #e08f62"
            v-tooltip.left="'Company Planner'"
          ></Avatar>
        </template>
        <template v-if="isAdmin">
          <Avatar
            label="AD"
            style="background-color: #cc7351"
            v-tooltip.left="'Administrator'"
          ></Avatar>
        </template>
      </AvatarGroup>
    </div> -->
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { usePlugin } from "./plugins";

export default defineComponent({
  name: "AppTopBar",
  // setup() {
  //   const { useState } = usePlugin();

  //   return { roles, isAdmin, isCompanyPlanner, isOperationPlanner, isViewer };
  // },
  methods: {
    onMenuToggle(event: any) {
      this.$emit("menu-toggle", event);
    },
  },
});
</script>
